export enum AnalyticsValueSources {
  VALUE = 'Value',
  VALUE_CHANGE = 'Value Change',
  GAIN = 'Gain',
  GAIN_CHANGE = 'Gain Change',
}
